import {
  jsonForm,
  get,
  formPost,
  formPut,
  urlPut,
  jsonDelete,
  formDelete,
  jsonPost,
} from '../utils/request';

// task list
export const getTaskList = (query) => {
  return get(window.$intercept.intercept2 + '/task/task', query);
};
// task add
export const getTaskAdd = (query) => {
  return formPost(window.$intercept.intercept2 + '/task/task', query);
};
// task edit
export const getTaskEdit = (query) => {
  return formPut(
    window.$intercept.intercept2 + '/task/task/' + query.id,
    query,
  );
};

// task det
export const getDelete = (query) => {
  return jsonPost(
    window.$intercept.intercept2 + '/task/deleteTaskByIds',
    query,
  );
};

// task map
export const getChatList = (query) => {
  return get(window.$intercept.intercept2 + '/task/situation', query);
};

// task manger
export const getManger = (query) => {
  return get(window.$intercept.intercept2 + '/task/managerList', query);
};
// task pluginGroup
export const getPluginGroup = (query) => {
  return get(window.$intercept.intercept2 + '/task/pluginGroup', query);
};
// info List
export const getTaskNode = (query) => {
  return get(window.$intercept.intercept2 + '/task/taskNode', query);
};

export const getPluginsmall = (query) => {
  return get(window.$intercept.intercept2 + '/task/pluginsmall', query);
};
